import React, { FC } from 'react'
import cx from 'classnames'

import { withMemo } from '../../decorators'
import { iconsKeys } from '../Icon/Icon.assets'
import { SelectProps } from '../Select'

import * as SC from './styled'

export type HeaderProps = {
  className?: string
  localeSelect: SelectProps
}

const Header: FC<HeaderProps> = (props) => {
  const { className, localeSelect } = props

  return (
    <SC.Container className={cx(className)}>
      <SC.LogoIcon icon={iconsKeys.Logo} />
      <SC.LocaleSelect {...localeSelect} />
    </SC.Container>
  )
}

export default withMemo(Header)
